import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

const InputRange = (props) => {
  const {
    onChange,
    name,
    id,
    min,
    max,
    step,
  } = props;

  const setRef = useCallback((e) => {
    if (e) {
      e.onchange = onChange || null;
    }
  }, []);

  return (
    <input
      type="range"
      ref={setRef}
      name={name}
      id={id}
      min={min}
      max={max}
      step={step} />
  );
};

InputRange.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  min: PropTypes.string.isRequired,
  max: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired,
};

export default InputRange;
